// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const NASP_REPORTING_ACTIONS = {

	// ── Import File ───────────────────────────────────────────────────────────
	NR_IMPORT_FILE_REQUEST: 'NR_IMPORT_FILE_REQUEST',
	NR_IMPORT_FILE_SUCCESS: 'NR_IMPORT_FILE_SUCCESS',
	NR_IMPORT_FILE_FAILURE: 'NR_IMPORT_FILE_FAILURE',

	// ── Get Last Result ───────────────────────────────────────────────────────
	NR_GET_LAST_RESULT_REQUEST: 'NR_GET_LAST_RESULT_REQUEST',
	NR_GET_LAST_RESULT_SUCCESS: 'NR_GET_LAST_RESULT_SUCCESS',
	NR_GET_LAST_RESULT_FAILURE: 'NR_GET_LAST_RESULT_FAILURE',

	// ── Send Email ────────────────────────────────────────────────────────────
	NR_SEND_EMAIL_REQUEST: 'NR_SEND_EMAIL_REQUEST',
	NR_SEND_EMAIL_SUCCESS: 'NR_SEND_EMAIL_SUCCESS',
	NR_SEND_EMAIL_FAILURE: 'NR_SEND_EMAIL_FAILURE',

	// ── Get Last Update ───────────────────────────────────────────────────────
	NR_GET_LAST_UPDATE_REQUEST: 'NR_GET_LAST_UPDATE_REQUEST',
	NR_GET_LAST_UPDATE_SUCCESS: 'NR_GET_LAST_UPDATE_SUCCESS',
	NR_GET_LAST_UPDATE_FAILURE: 'NR_GET_LAST_UPDATE_FAILURE',

};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Import File — `report` identifies which card is uploading
export const nrImportFileRequest = (report)          => ({ type: NASP_REPORTING_ACTIONS.NR_IMPORT_FILE_REQUEST, report });
export const nrImportFileSuccess = (report, payload) => ({ type: NASP_REPORTING_ACTIONS.NR_IMPORT_FILE_SUCCESS, report, payload });
export const nrImportFileFailure = (report, error)   => ({ type: NASP_REPORTING_ACTIONS.NR_IMPORT_FILE_FAILURE, report, error });

// Get Last Result — `report` identifies which card asked for it
export const nrGetLastResultRequest = (report)          => ({ type: NASP_REPORTING_ACTIONS.NR_GET_LAST_RESULT_REQUEST, report });
export const nrGetLastResultSuccess = (report, payload) => ({ type: NASP_REPORTING_ACTIONS.NR_GET_LAST_RESULT_SUCCESS, report, payload });
export const nrGetLastResultFailure = (report, error)   => ({ type: NASP_REPORTING_ACTIONS.NR_GET_LAST_RESULT_FAILURE, report, error });

// Send Email
export const nrSendEmailRequest = (report)          => ({ type: NASP_REPORTING_ACTIONS.NR_SEND_EMAIL_REQUEST, report });
export const nrSendEmailSuccess = (report, payload) => ({ type: NASP_REPORTING_ACTIONS.NR_SEND_EMAIL_SUCCESS, report, payload });
export const nrSendEmailFailure = (report, error)   => ({ type: NASP_REPORTING_ACTIONS.NR_SEND_EMAIL_FAILURE, report, error });

// Get Last Update
export const nrGetLastUpdateRequest = ()        => ({ type: NASP_REPORTING_ACTIONS.NR_GET_LAST_UPDATE_REQUEST });
export const nrGetLastUpdateSuccess = (payload) => ({ type: NASP_REPORTING_ACTIONS.NR_GET_LAST_UPDATE_SUCCESS, payload });
export const nrGetLastUpdateFailure = (error)   => ({ type: NASP_REPORTING_ACTIONS.NR_GET_LAST_UPDATE_FAILURE, error });
